import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { visuallyHidden } from '@mui/utils';

import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

import { GlobalTheme } from '../../theme';
import { common } from '@mui/material/colors';

export default function DiscoveryJourney() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [discoveryData, setDiscoveryData] = useState([]);
    const [swiperRef, setSwiperRef] = useState(null);

    const handleCardClick = (id) => {
        navigate(`/search/${id}`);
    }

    function stripHtmlTagsFromJson(json) {
        const clean = (value) => {
            if (typeof value === 'string') {
                return value.replace(/<[^>]*>/g, '').trim();
            } else if (Array.isArray(value)) {
                return value.map(clean);
            } else if (typeof value === 'object' && value !== null) {
                return Object.fromEntries(
                    Object.entries(value).map(([key, val]) => [key, clean(val)])
                );
            } else {
                return value; // number, boolean, null, etc.
            }
        };
    
        return clean(json);
    }
    useEffect(() => {
        fetch("https://aaryanholidays.in/frontend/discovery")
            .then(res => res.json())
            .then((result) => {
                result=stripHtmlTagsFromJson(result)
                const sortedData = result.sort((a, b) => {
                    const orderA = parseInt(a.appear_order, 10) || 0;
                    const orderB = parseInt(b.appear_order, 10) || 0;
                    return orderA - orderB;
                });
                
                setDiscoveryData(sortedData);
            })
            .catch(error => console.error("Error fetching discovery data:", error));
    }, []);



    if (!Array.isArray(discoveryData) || discoveryData.length === 0) {
        return <Typography>No discovery data available.</Typography>;
    }


    return (
        <ThemeProvider theme={GlobalTheme}>
            <CssBaseline />
            <Box container spacing={4}>
                {/* <Container maxWidth="lg"  aria-labelledby="popularToursHeading" component="section"> */}
                <Typography variant="h2" component="h2" color={common.black} id="popularToursHeading" sx={{  ...visuallyHidden }}>
                    Find your type of vacation
                </Typography>
                {/* </Container> */}
                <Swiper
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination, Autoplay]}
                    
                    onSwiper={setSwiperRef}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: true,
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1,

                        },
                        600: {
                            slidesPerView: 2,

                        },
                        1200: {
                            slidesPerView: 4,

                        }
                    }}
                    spaceBetween={0}
                >
                    {discoveryData.map(discovery => (
                        <SwiperSlide key={discovery.id}>
                            <Card id={`discoveryCard-${discovery.id}`} sx={{ boxShadow: 'none', borderRadius: 0 }} position="relative">
                                <CardActionArea
                                    id={`discoveryBtn-${discovery.id}`}
                                    onClick={() => handleCardClick(discovery.discovery)}
                                    sx={{
                                        backgroundColor: GlobalTheme.palette.warning.light,
                                        transition: 'transform 2s ease-in-out',
                                        '&:hover': {
                                            transform: 'scale(1.1)',
                                        },
                                    }}
                                    position="relative"
                                >
                                    <CardContent component='span' sx={{
                                        zIndex: 2,
                                        textAlign: 'left', px: 0, position: 'absolute', bottom: 0, left: 0, right: 0, backgroundColor: 'rgba(0, 0, 0, .5)', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: GlobalTheme.palette.common.white
                                    }}>
                                        <Typography variant="h2" component="span" sx={{ textTransform: 'uppercase' }}>
                                            {discovery.thumbnail_heading}
                                        </Typography>
                                        {/* <Typography variant="body2" color="text.secondary">
                                            {discovery.thumbnail_desc}
                                        </Typography> */}
                                    </CardContent>
                                    <CardMedia
                                        component="img"
                                        width="255"
                                        height="500"
                                        image={`https://aaryanholidays.in/express/uploads/${discovery.image}`}
                                        alt={discovery.alt}
                                        sx={{
                                            borderRadius: 0,
                                        }}
                                        className='discoveryCardImg'
                                        loading='lazy'
                                    />
                                </CardActionArea>
                            </Card>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Box>
        </ThemeProvider>
    );
}